var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLidSeal = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.65 59h-5.26V38.47c-5.24-1.2-8.41-6-7.09-10.77A9.677 9.677 0 0 1 48 21c5.43-.08 9.89 3.85 10 8.76a9.1 9.1 0 0 1-7.36 8.76V59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.65 60h-7.26V39.24c-2.53-.74-4.69-2.4-6.07-4.65a9.093 9.093 0 0 1-1-7.16C38.81 22.84 43.18 19.8 48 20h.17c5.9 0 10.73 4.34 10.83 9.75a10 10 0 0 1-7.36 9.54V60Zm-5.25-2h3.26V37.73l.77-.18c3.94-.93 6.65-4.12 6.59-7.77-.11-4.32-4.01-7.78-8.83-7.78h-.18c-4.19-.07-7.77 2.36-8.78 6-.52 1.89-.24 3.92.77 5.6a8.737 8.737 0 0 0 5.58 3.93l.78.17.04 20.3Z"
  })));
};
export default SvgLidSeal;